import { createContext, useContext } from 'react';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';

export type EnterpriseAssignedCoursesCollectionContextType = {
  isAssignedCoursesCollectionLoading: boolean;
  assignedCoursesCollection?: CarouselCollection;
};

const EnterpriseAssignedCoursesCollectionContext = createContext<EnterpriseAssignedCoursesCollectionContextType>({
  isAssignedCoursesCollectionLoading: false,
  assignedCoursesCollection: undefined,
});

export const useEnterpriseAssignedCoursesCollections = () => useContext(EnterpriseAssignedCoursesCollectionContext);

export default EnterpriseAssignedCoursesCollectionContext;
